"use strict";
exports.__esModule = true;
var react_cookie_1 = require("react-cookie");
var CookieBanner_1 = require("./CookieBanner");
exports["default"] = react_cookie_1.withCookies(CookieBanner_1["default"]);



//////////////////
// WEBPACK FOOTER
// ./~/react-cookie-banner/lib/CookieBannerUniversal.js
// module id = 458
// module chunks = 114276838955818